<ui-notification [uuid]="uuid()" [duration]="customDuration()" color="success">
  <ng-icon name="heroCheckCircle" size="24" class="!block size-6" slot="icon" />
  <p class="text-sm font-medium text-on-surface dark:text-on-surface-darkmode">
    {{ 'cockpit.energyInterfaces.details.notifications.editSuccess.title' | transloco }}
  </p>
  <p class="mt-1 text-sm text-on-surface-subtle dark:text-on-surface-subtle-darkmode">
    {{ 'cockpit.energyInterfaces.details.notifications.editSuccess.subtitle' | transloco }}
  </p>
  <div class="mt-3 flex gap-1">
    <ui-button size="small" mode="outlined" (click)="onClickUndo()" [loading]="loading()">
      {{ 'cockpit.energyInterfaces.details.notifications.editSuccess.undo' | transloco }}
    </ui-button>
    <ui-button size="small" mode="ghost" (click)="notification()?.dismiss()">
      {{ 'cockpit.energyInterfaces.details.notifications.editSuccess.dismiss' | transloco }}
    </ui-button>
  </div>
</ui-notification>
